import { ItemCardHeader, Link } from '@backstage/core-components';
import {
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button,
} from '@material-ui/core';
import React from 'react';

type HeaderCardProps = {
  title: string;
  description: string;
  url: string;
  actionTitle: string;
};

export const HeaderCard = (props: HeaderCardProps) => {
  return (
    <Card>
      <CardMedia>
        <ItemCardHeader title={props.title} />
      </CardMedia>
      <CardContent>{props.description}</CardContent>
      <CardActions>
        <Button component={Link} color="primary" to={props.url}>
          Read Docs
        </Button>
      </CardActions>
    </Card>
  );
};
